var exports = {
  "E": "Text__PRnIFM",
  "x": "truncate__0KCczl",
};

module.exports = exports;
